// extracted by mini-css-extract-plugin
module.exports = {"record":"_28e4784","main":"_4c4e0b8","amount":"_00cf99f","preferredLabel":"_4020148","arrow":"_b2874c4","active":"_991c70d"};